import React, { useEffect, useRef, useState } from "react";

import { Link, useLocation, useParams } from "react-router-dom";
import { getSearch } from "../../../MyApi/search";
import SearchIcon from "../../../Components/Common/svg/searchicon.jsx";

const SearchBar = () => {
  const tabs = [
    { name: "الكل", value: "all" },
    { name: "المنتجات", value: "product" },
    { name: "المتاجر", value: "store" },
  ];
  const [activeTab, setActiveTab] = useState("all");
  const [inputValue, setInputValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const timeOutId = useRef(null);

  const location = useLocation();

  useEffect(() => {
    setInputValue("");
    setSearchResults([]);
  }, [location.pathname]);

  const handelDisapper = () => {
    setInputValue("");
    setSearchResults([]);
  };

  const enhancedSearch = (e) => {
    const { value } = e.target;
    setInputValue(value);
    if (value.length >= 3) {
      setIsLoading(true);
      clearTimeout(timeOutId.current);
      timeOutId.current = setTimeout(async () => {
        try {
          let res = await getSearch(value);

          const stores =
            res?.data?.store?.map((s) => ({
              id: s.id,
              text: s.name,
              image: s.icon,
              slug: s.slug,
              type: "store",
            })) || [];

          const products =
            res?.data?.product?.map((p) => ({
              id: p.id,
              text: p.name,
              image: p.image,
              slug: p.slug,
              type: "product",
            })) || [];

          const formattedOptions = [...products, ...stores];

          const seeMoreOption = {
            id: "seeMore",
            text: "مشاهدة المزيد",
            slug: "seeMore",
            type: "all",
          };

          if (formattedOptions.length === 0) {
            setSearchResults([]);
          } else {
            setSearchResults(
              formattedOptions.length
                ? [...formattedOptions, seeMoreOption]
                : [],
            );
          }
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      }, 500);
    } else {
      setSearchResults([]);
      setIsLoading(false);
    }
  };

  const filteredResults =
    activeTab === "all"
      ? searchResults
      : searchResults.filter((item) => item.type === activeTab);

  return (
    <div className="col-4">
      <input
        type="search"
        className="form-control search-bar"
        onChange={enhancedSearch}
        placeholder="بحث.."
        value={inputValue}
      />
      {inputValue.length >= 2 && (
        <>
          <div className="hits-shadow" onClick={handelDisapper}></div>
          <div className="hits-container">
            <div className="d-flex justify-content-between">
              {tabs.map((tab, index) => (
                <div
                  key={index}
                  className={`tab-link ${activeTab === tab.value ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.value)}
                >
                  {tab.name}
                </div>
              ))}
            </div>
            {isLoading ? (
              <div className="spinner text-start"> جاري التحميل...</div>
            ) : (
              <>
                {inputValue.length >= 3 && filteredResults.length === 0 ? (
                  <div>لاتوجد نتائج</div>
                ) : (
                  <>
                    {filteredResults.map((search) => {

                        let linkTo = "/";

   if (search.id === "seeMore") {
    // زر مشاهدة المزيد حسب نوع العنصر نفسه
    if (search.type === "store") linkTo = "/stores";
    else if (search.type === "product") linkTo = "/products";
    else linkTo = "/"; // fallback
  } else {
    // الرابط لكل عنصر حسب النوع
    if (search.type === "store") linkTo = `/store/${search.id}`;
    else if (search.type === "product") linkTo = `/product/${search.id}`;
  }
                   return   <Link
                        key={search.id}
                        to={
                         linkTo
                        }
                        className="hit-child"
                        onClick={handelDisapper}
                      >
                        <div className="d-flex align-items-center gap-2  mt-3">
                          {/* <div className="avatar">
                            <img
                              src={search.image}
                              className="img-30 media rounded-circle"
                              alt=""
                            />
                          </div> */}
                          <div className="text-start">
                            <h6 className="font12  text-smoke">
                              {search.text}
                            </h6>
                          </div>
                        </div>
                      </Link>
})}
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchBar;
